import React from "react";

interface AboutChatbotCardProps {
  src: string;
  title: string;
  desc: string;
}

const AboutChatbotCard: React.FC<AboutChatbotCardProps> = ({
  src,
  title,
  desc,
}) => {
  return (
    <div className="about-cb-card-container">
      <div className="about-cb-card-image">
        <img loading="lazy" decoding="async" src={src} alt={title} />
      </div>

      <div className="about-cb-card-title">
        <p>{title}</p>
      </div>

      <div className="about-cb-card-desc">
        <p>{desc}</p>
      </div>
    </div>
  );
};

export default AboutChatbotCard;
